import { oidcSettings } from '@/config/oidc';

const redirect_uri = "/callback";
const post_logout_redirect_uri = "/logoutSuccess";
const silent_redirect_uri = "/silent-renew.html";

export const getOidcSettings = (settingsOidc) => {

    settingsOidc.redirect_uri = window.origin + redirect_uri
    settingsOidc.post_logout_redirect_uri = window.origin + post_logout_redirect_uri;
    settingsOidc.extraQueryParams = {}
    // settingsOidc.extraQueryParams.host = window.origin.split(".")[0] //"https://milton"
    settingsOidc.client_id = oidcSettings.clientId
    settingsOidc.client_secret = oidcSettings.clientSecret
    settingsOidc.scope = oidcSettings.scope
    settingsOidc.responseType = oidcSettings.responseType
    settingsOidc.grantType = oidcSettings.grantType
    settingsOidc.prompt = oidcSettings.prompt
    settingsOidc.silentRedirectUri = window.origin + silent_redirect_uri;
    settingsOidc.automaticSilentRenew = true;
    // settingsOidc.acr_values = window.location.hostname.split(".")[0] === "localhost"
    //     ? "tenant:novigo"
    //     : "tenant:" + window.location.hostname.split(".")[0];//oidcSettings.acrValues;//+ window.origin.split(".")[0].split("//")[1].split(":")[0];
    return settingsOidc;
}

export const getEnvironmentSettings = async () => {
    if (process.env.NODE_ENV == "development") {
        return (await fetch(window.origin + "/settings.dev.json")).json();
    }
    else if (process.env.NODE_ENV == "staging") {
        return (await fetch(window.origin + "/settings.stag.json")).json();
    }
    else {
        return await (await fetch(window.origin + "/settings.json")).json();
    }
}


